import React, { useState, useEffect } from "react";
import Style from './Dropdown.module.css';

const DropDown = (props) => {
    const { options, selectedOption, changeHandler } = props;
    const [selected, setSelected] = useState(selectedOption);
    const handleChange = (event) => {
        changeHandler(event.target.value);
        setSelected(event.target.value);
    }

    return (
        <>
            <select value={selected} className={Style.select} onChange={((event) => handleChange(event))}>
                {options.map((option, index) => <option value={option.value} className='form-control' key={index}> {option.name}</option>)}
            </select>
        </>
        
    ) 
}

export default DropDown;
